export const affiliateNameToken = () => '##affiliateName##';
export const affiliateLinkToken = (id) => `##affiliateLink${id}##`;

// The English defaults keep this module usable (and testable) without a
// translator; every caller inside the app passes the translated pair through
// `labels` so the Insert menu reads the same words the legacy `gd-dropdown`
// insert menu did (`frontend_resources_add_affiliate_name` /
// `frontend_resources_add_affiliate_link`).
export const DEFAULT_VARIABLE_LABELS = {
  affiliateName: 'Affiliate name',
  affiliateLink: 'Affiliate link',
};

export function buildVariableMenu(landingPages = [], options = {}) {
  const labels = { ...DEFAULT_VARIABLE_LABELS, ...(options.labels || {}) };

  return [
    { label: labels.affiliateName, token: affiliateNameToken(), kind: 'text' },
    ...landingPages.map((p) => ({
      label: `${labels.affiliateLink} · ${p.description}`,
      token: affiliateLinkToken(p.id),
      kind: 'link',
    })),
  ];
}

export function insertionPlan({ kind, token, hasSelection }) {
  if (!hasSelection) return { action: 'insertText', text: token };
  if (kind === 'link') return { action: 'wrapLink', href: token };
  return { action: 'replaceText', text: token };
}

export const appendTokenToText = (text, token) => `${text || ''}${token}`;

// Textareas retain their selection when a variable menu takes focus.
export function insertTokenAtSelection(text, token, start, end) {
  const value = text || '';
  const from = Number.isInteger(start) ? Math.max(0, Math.min(start, value.length)) : value.length;
  const to = Number.isInteger(end) ? Math.max(from, Math.min(end, value.length)) : from;
  return { text: value.slice(0, from) + token + value.slice(to), cursor: from + token.length };
}
